export const ACCREDITATION_AFFIRMATION_ATTEMPT = 'ACCREDITATION_AFFIRMATION_ATTEMPT';
export const ACCREDITATION_AFFIRMATION_SUCCESS = 'ACCREDITATION_AFFIRMATION_SUCCESS';
export const ACCREDITATION_AFFIRMATION_FAILURE = 'ACCREDITATION_AFFIRMATION_FAILURE';

export const CLEAR_ACCREDITATION_AFFIRMATION_STATE = 'CLEAR_ACCREDITATION_AFFIRMATION_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
